export default {

  Title: 'Ψηφίσαντες',

  Table: {
    Headers: {
      Id         : '#',
      Uid        : 'ΑΡ. ΤΑΥΤΟΤΗΤΑΣ',
      Corps      : 'ΚΛΑΔΟΣ',
      FirstName  : 'ΟΝΟΜΑ',
      LastName   : 'ΕΠΩΝΥΜΟ',
      FathersName: 'ΠΑΤΡΩΝΥΜΟ',
      Email      : 'EMAIL',
      Phone      : 'ΤΗΛΕΦΩΝΟ',
      VoteType   : 'ΨΗΦΟΣ',
      Time       : 'ΩΡΑ',
      Actions    : ''
    }
  }
}
